import type { TimelineStageKey } from '@/api/cockpit';
import { READONLY_DRAFT_AND_AFTER_STATES } from './readonly-draft-and-after-states';

export function isQueueItemReadOnly(state: string, stageKey: TimelineStageKey): boolean {
  if (READONLY_DRAFT_AND_AFTER_STATES.has(state)) return true;
  if (
    stageKey === 'confirm' ||
    stageKey === 'approval' ||
    stageKey === 'acknowledgement' ||
    stageKey === 'resolved'
  )
    return true;
  return stageKey === 'draft' && state !== 'Waiting for Draft Creation';
}
